<!--
 * @Author: DY
 * @Date: 2024-12-02 18:57:08
 * @LastEditTime: 2026-02-28 15:58:14
 * @Description: 跨仓调拨管理表单
 * @FilePath: \ShiMo_Mobile\src\views\storage\crossWarehouseAllocationApply\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="allocationForm commonFormStyles">
            <HeaderNav
                header-title="跨仓调拨单"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <div class="formList">
                <van-collapse v-model="activeCollapseItem">
                    <van-collapse-item title="基本信息" name="1">
                        <van-field
                            disabled
                            label="调拨单号"
                            placeholder="自动生成"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            v-model="formData.TransferNo"
                        ></van-field>
                        <van-field
                            readonly
                            label="关联需求计划单"
                            placeholder="请选择关联需求计划单"
                            :disabled="isDisabled"
                            :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                            v-model="formData.CollectNumber"
                            @click="selectPlanSheet"
                        ></van-field>
                        <van-field
                            readonly
                            :disabled="isDisabled"
                            label="调出仓库"
                            placeholder="请选择调出仓库"
                            :left-icon="require('@/assets/images/icons/icon_3@2x.png')"
                            v-model="formData.OutStockName"
                            @click="selectCallOutWarehouse('OutStockName')"
                        ></van-field>
                        <van-field
                            readonly
                            label="出库库员"
                            placeholder="请选择调出仓库"
                            :disabled="isDisabled"
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            v-model="formData.OutStoremanName"
                            @click="selectCallOutWarehouse('OutStockName')"
                        ></van-field>
                        <van-field
                            readonly
                            label="调入仓库"
                            placeholder="请选择调入仓库"
                            :disabled="isDisabled"
                            :left-icon="require('@/assets/images/icons/icon_3@2x.png')"
                            v-model="formData.InStockName"
                            @click="selectCallOutWarehouse('InStockName')"
                        ></van-field>
                        <van-field
                            label="入库库员"
                            placeholder="请选择调入仓库"
                            :disabled="isDisabled"
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            v-model="formData.InStoremanName"
                            @click="selectCallOutWarehouse('InStockName')"
                        ></van-field>
                        <van-field
                            disabled
                            label="制单人"
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            v-model="formData.CreatorName"
                        ></van-field>
                        <van-field
                            disabled
                            label="制单时间"
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            v-model="formData.CreationTime"
                        ></van-field>
                        <van-field
                            disabled
                            label="状态"
                            :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                            v-model="Status"
                        ></van-field>
                        <van-field
                            label="备注"
                            type="textarea"
                            :rows="4"
                            :disabled="isDisabled"
                            :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                            v-model="formData.Remarks"
                        ></van-field>
                    </van-collapse-item>
                    <van-collapse-item name="2">
                        <template #title>
                            <span>物料明细</span>
                            <van-icon name="add" v-if="!isDisabled" @click.stop="selectMaterials"></van-icon>
                        </template>
                        <div class="currencyTableStyle">
                            <table>
                                <thead>
                                    <tr>
                                        <th>物料代码</th>
                                        <th>短描述</th>
                                        <th>调拨数量</th>
                                        <th>实时库存</th>
                                        <th v-if="!isDisabled">
                                            操作
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in formData.materials" :key="`materials_${index}`">
                                        <td>{{ item.MaterialCode }}</td>
                                        <td>{{ item.MaterialShortName }}</td>
                                        <td>
                                            <input type="number" :disabled="isDisabled" v-model="item.VolumeTransfer">
                                        </td>
                                        <td>{{ item.Volume }}</td>
                                        <td v-if="!isDisabled">
                                            <van-icon name="clear" @click="deleteMaterial(index)"></van-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" @click="submitAllocationForm">
                        提交
                    </button>
                    <button class="confirm" @click="saveAllocationForm">
                        保存
                    </button>
                </template>
                <template v-else>
                    <button class="confirm" @click="closeAllocationForm">
                        关闭
                    </button>
                </template>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import util from '@/assets/js/utils';

export default {
    // 库位表单
    name: 'allocation-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/crossWarehouseAllocationApply') {
            this.$store.commit('noKeepAlive', 'allocation-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isDisabled: false,
            formData: {
                Id: '',
                TransferNo: '',
                MaterialCategory: 1,
                CollectNumber: '',
                OutStockId: '',
                OutStockCode: '',
                OutStockName: '',
                OutStoremanId: '',
                OutStoremanName: '',
                InStockId: '',
                InStockCode: '',
                InStockName: '',
                InStoremanId: '',
                InStoremanName: '',
                MaterialCodes: '',
                MaterialShortNames: '',
                VolumeTransfer: 0,
                OutStockConfirmTime: '',
                Status: 0,
                Remarks: '',
                CreatorName: '',
                CreationTime: '',
                materials: [],
            },
            materialIndex: null,
            activeCollapseItem: ['1', '2'],
            selectWarehouseType: '',
            Status: '',
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.planSheet) {
            this.formData.CollectNumber = this.$route.params.planSheet[0].collect_number;
        }
        if (this.$route.params.OutStockName) {
            this.formData.OutStockId = this.$route.params.OutStockName[0].id;
            this.formData.OutStockCode = this.$route.params.OutStockName[0].stock_code;
            this.formData.OutStockName = this.$route.params.OutStockName[0].stock_name;
            this.formData.OutStoremanId = this.$route.params.OutStockName[0].storeman_id;
            this.formData.OutStoremanName = this.$route.params.OutStockName[0].storeman_name;
        }
        if (this.$route.params.InStockName) {
            this.formData.InStockId = this.$route.params.InStockName[0].id;
            this.formData.InStockCode = this.$route.params.InStockName[0].stock_code;
            this.formData.InStockName = this.$route.params.InStockName[0].stock_name;
            this.formData.InStoremanId = this.$route.params.InStockName[0].storeman_id;
            this.formData.InStoremanName = this.$route.params.InStockName[0].storeman_name;
        }
        if (this.$route.params.materials) {
            this.$route.params.materials.forEach(item => {
                this.formData.materials.push({
                    MaterialCode: item.material_code,
                    MaterialName: item.material_name,
                    MaterialShortName: item.material_short_name,
                    VolumeTransfer: 0,
                    Volume: item.volume,
                });
            });
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            const type = this.$route.params.type;
            if (type !== 'add') {
                const id = this.$route.params.data.Id;
                this.formData = await this.getAllocationFormRequrst(id);
                if (this.$route.params.data.Status !== 0) {
                    this.isDisabled = true;
                }
            }
            if (type === 'add') {
                this.formData.CreatorName = this.$takeTokenParameters('Name');
                this.formData.CreationTime = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
            }
            this.Status = this.loadStatus(this.formData.Status);
        },

        loadStatus(nub) {
            const staus = ['待提交', '确认中', '确认中', '待出库', '已出库', '已作废'];
            return staus[nub];
        },

        // 选择需求计划单
        selectPlanSheet(index) {
            if (this.isDisabled) {return;}
            this.materialIndex = index;
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectTable',
                params: {
                    sourcePath: 'allocationForm',
                    listCode: 'choose_plan_collect_list',
                    callbackDataKey: 'planSheet',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    SearchKey: 'searchKey',
                    pageIndex: 0,
                    initIndex: 0,
                    headerList: [{
                        name: '采购计划编号',
                        code: 'collect_number',
                        width: '50%',
                    }, {
                        name: '采购日期',
                        code: 'month',
                        width: '25%',
                    }, {
                        name: '申请方式',
                        code: 'method_str',
                        width: '25%',
                    }],
                },
            });
        },

        // 选择调出仓库
        selectCallOutWarehouse(type) {
            if (this.isDisabled) {return;}
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库',
                    sourcePath: 'allocationForm',
                    listCode: 'choose_stock',
                    callbackDataKey: type,
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '仓库号',
                        code: 'stock_no',
                        icon: 'icon_34@2x',
                    }, {
                        name: '仓库类别',
                        code: 'stock_category_name',
                        icon: 'icon_13@2x',
                    }, {
                        name: '库位数量',
                        code: 'grid_count',
                        icon: 'icon_16@2x',
                    }, {
                        name: '主要存放',
                        code: 'main_storage',
                        icon: 'icon_32@2x',
                    }, {
                        name: '管理单位',
                        code: 'manage_org_name',
                        icon: 'icon_4@2x',
                    }, {
                        name: '管理部门',
                        code: 'manage_dept_name',
                        icon: 'icon_29@2x',
                    }, {
                        name: '仓库保管员',
                        code: 'storeman_name',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },

        // 新增物料
        selectMaterials() {
            if (this.isDisabled) {return;}
            this.$router.isBack = 2;
            if ((this.formData.OutStockId || '') === '') {
                this.$toast('请先选择仓库！');
                return;
            }
            this.$router.replace({
                name: 'selectTable',
                params: {
                    sourcePath: 'allocationForm',
                    requestUrl: `/basicplatform/tabledata?stock_id=${this.formData.OutStockId}&material_category=1`,
                    listCode: 'choose_stock_material',
                    callbackDataKey: 'materials',
                    relationKey: 'material_code',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    SearchKey: 'searchKey',
                    pageIndex: 0,
                    initIndex: 0,
                    type: 'checkbox',
                    headerList: [{
                        name: '物料代码',
                        code: 'material_code',
                    }, {
                        name: '物料短描述',
                        code: 'material_short_name',
                    }, {
                        name: '实时库存',
                        code: 'volume',
                    }],
                },
            });
        },

        // 删除物料
        deleteMaterial(index) {
            this.formData.materials.splice(index, 1);
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'crossWarehouseAllocationApply',
                params: {
                    saveCallback: true,
                },
            });
        },

        async submitAllocationForm() {
            const res = await this.submitAllocationFormRequrst(this.formData.Id);
            if (res) {
                this.$toast.success('提交成功');
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'crossWarehouseAllocationApply',
                    params: {
                        saveCallback: true,
                    },
                });
            }
        },

        async saveAllocationForm() {
            this.$toast.loading({ overlay: true, duration: 0 });
            try {
                const res = await this.saveAllocationFormRequrst(this.formData);
                if (res) {
                    this.$toast.success('保存成功');
                    this.$router.isBack = 1;
                    this.$router.replace({
                        name: 'crossWarehouseAllocationApply',
                        params: {
                            saveCallback: true,
                        },
                    });
                }
            } finally {
                this.$toast.clear();
            }
        },

        getAllocationFormRequrst(id) {
            return this.$axios.$get(`/interfaceApi/procurement/stock_transfer/get_transfer/${id}`);
        },

        saveAllocationFormRequrst(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/stock_transfer/transfer_save', requestData);
        },

        submitAllocationFormRequrst(id) {
            return this.$axios.$put(`/interfaceApi/procurement/stock_transfer/transfer_submit/${id}`, {});
        },
    },
};
</script>
<style lang="stylus">
.allocationForm
    background #F0F0F0
    .formList
        .van-collapse
            .van-cell__title
                .van-icon
                    margin-left: 10rpx
        .currencyTableStyle
            table
                border-radius: 4rpx
                td
                    input
                        width 100%
                        height 30rpx
                        margin: 3rpx 0
                        border 1px solid #ADC7E0
                        background: #FAFBFE
                        border-radius: 4rpx
                        text-align: center
                .van-icon
                    color #E93543
            .addBtn
                color #E93543
                float: right
                margin-bottom: 5rpx
                padding 0 10rpx
                border-radius: 3rpx
                border-color rgba(233, 55, 67, 0.20)
                background: rgba(233, 55, 67, 0.10)
</style>
